import { useAuth } from '../context/AuthContext';
import { ROLES } from '../constants/roles';

const AdminPanel = () => {
  const { auth } = useAuth();

  if (auth.user?.role !== ROLES.SUPER_ADMIN) return null;

  return <div>Super Admin Settings</div>;
};

export default AdminPanel
